import { render, staticRenderFns } from "./VideoReport.vue?vue&type=template&id=a628bd88&"
import script from "./VideoReport.vue?vue&type=script&lang=js&"
export * from "./VideoReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports